<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px" max-height="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Criar Pendencia</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="obeservacao"
                  label="Observação"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Sair </v-btn>
          <v-btn
            color="blue darken-1"
            :disabled="obeservacao === ''"
            text
            @click="save"
          >
            Criar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import ApiService from "@/common/services/http/api.service";

export default {
  name: "CriarPendenciaDialog",
  props: {
    registro: Object,
    dialog: Boolean,
    usuarioID: Number,
  },
  data: () => ({
    obeservacao: "",
  }),
  methods: {
    sync() {
      this.$emit("sync-dialog", { dialog: false });
    },
    close() {
      this.obeservacao = "";
      this.sync();
    },
    async save() {
      const self = this;
      Swal.fire({
        title: "Gerar Pendência",
        text: "Deseja realmente criar uma nova Pendência para esse Registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode gerar!",
      })
        .then(function (result) {
          if (result.value) {
            return new Promise((resolve) => {
              ApiService.post(`registro/CriarPendencia/${self.registro.id}`, {
                observacao: self.obeservacao,
                usuarioID: self.usuarioID,
              }).then(({ data }) => {
                if (data.success) {
                  resolve(data);

                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Pendência gerada com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              });
            });
          }
        })
        .finally(() => {
          this.obeservacao = "";
          self.dialog = false;
          this.sync();
        })
        .catch(() => this.sync());
    },
  },
};
</script>
